<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-积分管理-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户">
          <el-input v-model="formInline.user" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.type" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(v, i) in type" :key="i" :label="v" :value="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.status" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(v, i) in status" :key="i" :label="v" :value="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange" clearable  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openPopup('add')" v-auth="'/user/points_apply/add'">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="apply_id" label="ID" width="60"></el-table-column>
          <el-table-column prop="type" label="类型" width="100" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.points.type_text}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="points.title" label="标题">
            <template slot-scope="scope">
              <p>{{scope.row.points.title}}</p>
              <p class="gray9">{{scope.row.points.intro}}</p>
              <p class="gray9">{{scope.row.points.point_text}}</p>
            </template>
          </el-table-column>

          <el-table-column prop="user" label="用户" width="200">
            <template slot-scope="scope">
              <div class="d-s-c" v-if="scope.row.user">
                <!-- <img v-if="scope.row.user.avatarUrl" :src="scope.row.user.avatarUrl" width="60px" height="60px" /> -->
                <div class="ml10">
                  <p class="f14 fb">{{ scope.row.user.nickName }} <el-tag type="info" class="style1-tag" v-if="scope.row.user.grade.name">{{ scope.row.user.grade.name }}</el-tag></p>
                  <p class="gray3" v-if="scope.row.user.mobile">手机：{{ scope.row.user.mobile }}</p>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="point" label="申请积分" align="center"></el-table-column>
          
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <p class="red" v-if="scope.row.status==3">已驳回</p>
              <p class="green" v-else-if="scope.row.status==2">已通过</p>
              <p class="" v-else-if="scope.row.status==1">申请中</p>
              <p class="gray9" v-else>暂无</p>
              <p v-if="scope.row.status==3">{{scope.row.reject_reason}}</p>
            </template>
          </el-table-column>
          
          <el-table-column prop="create_time" label="申请时间"></el-table-column>
          <el-table-column prop="name" label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="openPopup('audit', scope.row)" type="text" size="small" v-if="scope.row.status==1" v-auth="'/user/points_apply/audit'">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--弹窗引入-->
    <Audit v-if="show_popup['audit']" :is_open="show_popup['audit']" :oneform="Oneform" @closeDialog="closeDialogFunc($event, 'audit')"></Audit>
    <Add v-if="show_popup['add']" :is_open="show_popup['add']" :type="type" :oneform="Oneform" @closeDialog="closeDialogFunc($event, 'add')"></Add>

  </div>
</template>

<script>
  import PointsApplyApi from '@/api/study/points_apply.js';
  import Audit from './part/Audit.vue';
  import Add from './part/AddPoint.vue';
  export default {
    components: {
      Audit,
      Add
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user: '',
          create_time: '',
          type: ''
        },
        type: [],
        status: [],
        /*选择的当前行对象数据*/
        Oneform:{
          type:'edit',
          model:{}
        },
        show_popup: {
          audit: false,
          add: false,
        },
      };
    },
    created() {
      /*获取列表*/
      this.getData();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        PointsApplyApi.getList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.type = data.data.type;
          self.status = data.data.status;
        }).catch(error => {

        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getData();
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.Oneform.type = name;
        if (name == 'edit') name = 'add';
        this.show_popup[name] = true;
        if(item&&typeof(item)!='undefined') this.Oneform.model = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/points/part/Apply.vue